import { useEffect } from "react";
import { Redirect, useParams } from "react-router-dom";

import flocknoteStateHooks from "Flocknote/stateHooks";

import { useShouldShowSignupBoard } from "Signups/SignupView/SignupSheet/utils/useShouldShowSignupBoard";
// import { useSignups } from "Signups/state";

import { SIGNUP_ITEM_TABS } from "./const";

export default function AutoNavigateToLastItemTab({
  forceToAddItem = false,
  isAdminOfAnyGroup = false,
}) {
  // const [
  //   {
  //     currentSignupList,
  //   },
  // ] = useSignups();
  const { signupTab, signupItemID, signupItemTab, signupListID } = useParams();

  const [{ hasSignupsProfileFields }] =
    flocknoteStateHooks.useNetworkMetadata();

  const shouldShowSignupBoard = useShouldShowSignupBoard();

  useEffect(
    function saveLastItemTab() {
      if (!getIsValidItemTab(signupItemTab)) return;

      localStorage.setItem("signupsLastItemTab", signupItemTab);
    },
    [signupItemTab]
  );

  const itemPath = `/signups/${signupListID}/items/${signupItemID}`;

  if (forceToAddItem && signupItemTab && signupItemTab !== "info") {
    return <Redirect to={`${itemPath}/info`} />;
  }
  
  if (!isAdminOfAnyGroup && signupItemTab && signupItemTab !== "info") {
    return <Redirect to={`${itemPath}/info`} />;
  }
  
  if (!hasSignupsProfileFields && signupItemTab === "additional-info") {
    return <Redirect to={`${itemPath}/info`} />;
  }
  
  if (typeof signupItemTab !== "string" || signupItemTab.length === 0) {
    const savedTab = localStorage.getItem("signupsLastItemTab");
    
    if (getIsValidItemTab(savedTab)) {
      return <Redirect to={`${itemPath}/${savedTab}`} />;
    }
  }
  
  /*
  We prevent redirecting when the user has opened a respondent's profile
  on the Signup Board ("Respondent Data").
  This is hacky, but is necessary due to how we append "/user/:userID" to
  whatever the current route is when viewing a profile.
  See: `function loadUserProfile` within www/js/people.js
  */
 let isViewingRespondentProfile = false;
 if (
   shouldShowSignupBoard &&
   signupTab === "respondents" &&
   signupItemID === "user"
  ) {
    const itemTabAsInt = parseInt(signupItemTab);
    if (!Number.isNaN(itemTabAsInt) && itemTabAsInt > 0) {
      // path is something like: /signups/1/respondents/user/2
      isViewingRespondentProfile = true;
    }
  }
  
  if (!(getIsValidItemTab(signupItemTab) || isViewingRespondentProfile)) {
    return <Redirect to={`${itemPath}/${SIGNUP_ITEM_TABS.respondents}`} />;
  }

  return null;
}

function getIsValidItemTab(itemTab) {
  return Object.values(SIGNUP_ITEM_TABS).includes(itemTab);
}
